module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "tabs-menu"
  }, _vm._l((_vm.list), function(ref, index) {
    var after = ref.after;
    var classes = ref.classes;
    var title = ref.title;
    var to = ref.to;

    return _c('li', {
      key: index,
      staticClass: "tabs-menu__item"
    }, [(to) ? _c('router-link', {
      staticClass: "tabs-menu__link",
      class: classes,
      attrs: {
        "to": to
      }
    }, [_vm._v(_vm._s(title))]) : _c('button', {
      staticClass: "tabs-menu__link",
      class: classes,
      on: {
        "click": function($event) {
          return _vm.onClick(index)
        }
      }
    }, [_vm._v(_vm._s(title))]), (after) ? _c('span', {
      staticClass: "tabs-menu__after"
    }, [_vm._v("(" + _vm._s(after) + ")")]) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4461e290","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/tab/menu/component.vue
// module id = 6faeb5334f2e26fd4573
// module chunks = 0